<div class="page-container" *ngIf="model$ | async as model; else noData">
  <h1>Ihr Angebot zu {{ subject$ | async }}</h1>
  <ng-container *ngIf="info$ | async as info">
    <section>
      <app-hint-card [outlined]="true">
        <h2 style="margin-top: 1rem; margin-bottom: 0; padding-bottom: 0">
          Ihr Netzbetreiber möchte Ihnen folgende Informationen zum Angebot mitgeben:
        </h2>
        <ng-container *ngIf="info.startsWith('<'); else infoText">
          <div [innerHTML]="info"></div>
        </ng-container>
        <ng-template #infoText>
          <p>{{ info }}</p>
        </ng-template>
      </app-hint-card>
    </section>
  </ng-container>
  <section>
    <h2>Zusammenfassung</h2>
    <p>
      Bitte überprüfen Sie Ihre Angaben nochmals auf Vollständigkeit und Richtigkeit bevor Sie das Angebot
      annehmen.
    </p>
    <app-order-request-wizard-summary [model]="model" />
  </section>
  <form [formGroup]="offerForm">
    <section>
      <form-row>
        <mat-checkbox [formControl]="offerForm.controls.acceptDataAccuracy">
          <p>Ich bestätige die Richtigkeit und Vollständigkeit meiner Daten.*</p>
          <mat-error
            style="color: red"
            *ngIf="
              offerForm.controls.acceptDataAccuracy.invalid && offerForm.controls.acceptDataAccuracy.touched
            ">
            Bitte bestätigen Sie die Richtigkeit Ihrer Daten
          </mat-error>
        </mat-checkbox>
      </form-row>
    </section>

    <section>
      <h2>Ihre Bestellung</h2>
      <form-row>
        <mat-checkbox [formControl]="offerForm.controls.acceptOfferConditions">
          <p
            *ngIf="
              !(isFreeOfCharge$ | async) ||
              model.connectionChangeRequestType !== ConnectionChangeRequestTypeEnum.DISCONNECTION
            ">
            Ich erkenne hiermit an, dass die
            {{
              !(isFreeOfCharge$ | async)
                ? 'kostenpflichtige Bestellung zu dem angebotenen Preis'
                : 'kostenlose Dienstleistung'
            }}
            unter dem Vorbehalt der technischen und wirtschaftlichen Machbarkeit steht. Sollte dies nicht der
            Fall sein, werden wir Ihnen nach Möglichkeit ein angepasstes Angebot unterbreiten.*
          </p>
          <p
            *ngIf="
              (isFreeOfCharge$ | async) &&
              model.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.DISCONNECTION
            ">
            Ich habe zu Kenntnis genommen, dass die Anschlusstrennung kostenfrei ist. Ich bin damit
            einverstanden, dass eine spätere Anschluss-Wiederherstellung kostenpflichtig zu bestellen ist.*
          </p>
          <mat-error
            style="color: red"
            *ngIf="
              offerForm.controls.acceptOfferConditions.invalid &&
              offerForm.controls.acceptOfferConditions.touched
            ">
            Bitte bestätigen Sie die Bedingungen
          </mat-error>
        </mat-checkbox>
      </form-row>
      <ng-container *ngIf="configCheckboxData$ | async as checkboxData">
        <form *ngIf="!!checkboxData.form.length">
          <form-row *ngFor="let control of checkboxData.form.controls; let index = index">
            <mat-checkbox [formControl]="control">
              <div [innerHTML]="checkboxData.texts[index] | safeHtmlPipe"></div>
              <mat-error style="color: red" *ngIf="control.touched && control.invalid">
                Bitte bestätigen Sie die Bedingungen
              </mat-error>
            </mat-checkbox>
          </form-row>
        </form>
      </ng-container>
    </section>
  </form>
  <form-row>
    <button
      *ngIf="(configCheckboxData$ | async)?.form as checkboxForm; else noCheckbox"
      color="primary"
      mat-stroked-button
      (click)="submit(model, checkboxForm)">
      {{ !(isFreeOfCharge$ | async) ? 'Kostenpflichtig bestellen' : 'Kostenfrei bestellen' }}
    </button>
    <ng-template #noCheckbox>
      <button color="primary" mat-stroked-button (click)="submit(model)">
        {{ !(isFreeOfCharge$ | async) ? 'Kostenpflichtig bestellen' : 'Kostenfrei bestellen' }}
      </button>
    </ng-template>
  </form-row>
  <br />
</div>

<ng-template #noData>
  <app-error
    [errorMessage]="
      'Leider konnten wir Ihr Angebot nicht finden. Bitte überprüfen Sie Ihren Link und stellen sicher, dass das Zeitfenster für Ihre Rückmeldung noch nicht abgelaufen ist.'
    " />
</ng-template>
